import { Navigate, Outlet, useLocation } from "react-router-dom";

// This component protects the verify-otp route from direct access
const ProtectedOtpRoute = () => {
  const location = useLocation();
  
  // Check for valid redirect sources - either from localStorage or from state
  const hasValidRedirectSource = () => {
    // Check if we have a valid state with email (came from forgot-password or register)
    if (location.state?.email) {
      return true;
    }
    
    // Check if there are valid entries in localStorage
    const resetPasswordEmail = localStorage.getItem('resetPasswordEmail');
    const registeredUserData = localStorage.getItem('registeredUser');
    
    return !!(resetPasswordEmail || registeredUserData);
  };
  
  // If no valid redirect source, redirect to login
  if (!hasValidRedirectSource()) {
    return <Navigate to="/" replace />;
  }
  
  // Otherwise, render the protected route
  return <Outlet />;
};

export default ProtectedOtpRoute; 